import { render, staticRenderFns } from "./BranchMsgAdd.vue?vue&type=template&id=0d1b8c4a&scoped=true&"
import script from "./BranchMsgAdd.vue?vue&type=script&lang=js&"
export * from "./BranchMsgAdd.vue?vue&type=script&lang=js&"
import style0 from "./BranchMsgAdd.vue?vue&type=style&index=0&id=0d1b8c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1b8c4a",
  null
  
)

export default component.exports